<kendo-autocomplete
[data]="packages"
[filterable]="true"
[valueField]="'nom'"
[value]="package.nom"
(valueChange)="onValueChange($event)"
(filterChange)="handleFilter($event)"
>
</kendo-autocomplete>